import { defineComponent as _defineComponent } from 'vue'
import BCXSidebarHelpContainer from '@/components/molecules/BCXSidebarHelpContainer.vue';
import { User } from '@/models/User';
import SidebarUserSelect from '@/components/molecules/SidebarUserSelect.vue';
import { ref } from 'vue';
import { useRouter } from 'vue2-helpers/vue-router';
import BCXActionBoxMessageBox from '@/components/molecules/BCXActionBoxMessageBox.vue';
import { AvailabilityInterface } from '@/models/Availability';
import useMessengerState from '@/state/messenger/messengerState';
import { whenever } from '@vueuse/core';
import BCXRadio from '@/components/molecules/forms/BCXRadio.vue';
import { getDisplayName } from '@/utils/user';
import useProjectsContractsActionState from './myProjectsContractsActionState';
import useContractOverview from '../../composables/useContractOverview';


export default /*#__PURE__*/_defineComponent({
  __name: 'MyProjectContractsNewContractAction',
  setup(__props) {

const router = useRouter();

const { isOpened: isMessengerOpened } = useMessengerState();
const { mode } = useProjectsContractsActionState();

const user = ref<User | null>(null);
const availability = ref<AvailabilityInterface | null | false>(null);
const message = ref('');

const whoIsClient = ref<'me'|'partner'|null>(null);

whenever(user, () => {
  isMessengerOpened.value = false;
});

const { submitNewContract, newContractProperties } = useContractOverview();

const submit = async () => {
  if (!whoIsClient.value) {
    return;
  }
  newContractProperties.client = (whoIsClient.value === 'me');
  newContractProperties.contractPartnerId = user.value?.userId ?? '';
  newContractProperties.message = message.value;
  const contract = await submitNewContract();
  mode.value = 'contract-actions';
  router.push({ name: 'myProjectsContract', params: { contractId: contract.contractId } });
};


return { __sfc: true,router, isMessengerOpened, mode, user, availability, message, whoIsClient, submitNewContract, newContractProperties, submit, BCXSidebarHelpContainer, SidebarUserSelect, BCXActionBoxMessageBox, BCXRadio, getDisplayName }
}

})